import React, { Component } from 'react';
import { UsersService } from '../../services/user';
import './sobre.css';

import {
  HeaderShelf,
  SidebarRoundedIcons,
  Footer
} from '../../components';

export default class ViewSobre extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isUserLoggedIn: false
    };
  }

  componentDidMount() {
    const user = UsersService.getUser();
    this.setState({ isUserLoggedIn: user !== null });
  }

  onBack() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  render() {
    const { loading, isUserLoggedIn } = this.state;
    
    if (loading) {
      return (
        <div className="rdp-react-template-view-sobre">
          <div className="rdp-react-template-view-sobre-loading">
            <div className="rdp-react-template-view-sobre-loader"></div>
          </div>
        </div>
      );
    }

    return (
      <div className="rdp-react-template-view-sobre">
        <div className="rdp-react-template-view-sobre-header">
          <HeaderShelf
            onSignOut={() => this.signOut()}
            renderSearch={false}
            isUserLoggedIn={isUserLoggedIn}
          />
        </div>

        {isUserLoggedIn && (
          <div className="rdp-react-template-view-sobre-sidebar">
            <SidebarRoundedIcons />
          </div>
        )}

        <div className="rdp-react-template-view-sobre-main">
          <div className="rdp-react-template-view-sobre-container">
            <div className="rdp-react-template-view-sobre-header-section">
              <h1 className="rdp-react-template-view-sobre-title">Sobre</h1>
            </div>

            <div className="rdp-react-template-view-sobre-content">
              <div className="rdp-react-template-view-sobre-section">
                <div className="rdp-react-template-view-sobre-text-image">
                  <p className="rdp-react-template-view-sobre-text">
                    A Editora Senac São Paulo foi criada em agosto de 1995 com
                    o propósito de ampliar o acervo de conteúdos educacionais
                    para as áreas inovadoras de qualificação profissional do
                    Senac São Paulo, dando apoio ao professor em sala de aula
                    e possibilidade aos alunos de entrar em contato com
                    leituras básicas e complementares para sua formação.
                  </p>
                  {/* <div className="rdp-react-template-view-sobre-image-books"></div> */}
                </div>
              </div>

              <div className="rdp-react-template-view-sobre-section">
                <h2 className="rdp-react-template-view-sobre-subtitle">Áreas de atuação</h2>
                <p className="rdp-react-template-view-sobre-text">
                  A Editora Senac São Paulo atua nas áreas de gastronomia e
                  enologia, moda, meio ambiente, comunicação e artes, gestão
                  de negócios, beleza e estética, ciências humanas, design e
                  arquitetura, educação, desenvolvimento social, tecnologia
                  da informação, saúde, turismo e hotelaria.
                  <br /><br />
                  Com 15 milhões de exemplares vendidos, mais de 900 mil
                  títulos impressos ativos, 1.244 mil títulos em formato
                  digital e 800 autores em catálogo, a Editora Senac São
                  Paulo oferece publicações nas áreas técnica, científica,
                  educação profissional e universitária, e temas
                  contemporâneos em livros impressos e digitais.
                </p>
              </div>

              <div className="rdp-react-template-view-sobre-section">
                <h2 className="rdp-react-template-view-sobre-subtitle">
                  Biblioteca Digital Senac
                </h2>
                <p className="rdp-react-template-view-sobre-text">
                  Os títulos estão disponibilizados nos formatos PDF e ePub
                  (electronic publication – ideal para leitura de livros
                  digitais), tornando a experiência de estudos fluida e
                  adaptável às necessidades dos alunos.
                </p>
              </div>

              <div className="rdp-react-template-view-sobre-section">
                <h2 className="rdp-react-template-view-sobre-subtitle">Linha editorial</h2>
                <p className="rdp-react-template-view-sobre-text">
                  A editora foi criada para apoiar as atividades
                  educacionais do Senac São Paulo. Além desse conteúdo, o
                  catálogo possui publicações voltadas ao mercado nas
                  diversas áreas em que a instituição atua. O acervo também
                  abrange temas relevantes e de interesse geral, como
                  política, filosofia, história e literatura.
                  <br /><br />
                  Publicar livros didáticos está no DNA da Editora Senac São
                  Paulo. Oficialmente lançada em 2012, a linha de didáticos
                  atende a estudantes e profissionais que ingressam ou
                  querem se desenvolver no mercado de trabalho. Além do viés
                  formativo, enfoca também a responsabilidade social e
                  ambiental.
                  <br /><br />
                  Diversas coleções fazem parte da história editorial do
                  Senac, como a Série Universitária, desenvolvida em forma
                  de material didático para as disciplinas oferecidas nos
                  cursos de educação a distância do Senac.
                  <br /><br />
                  Além disso, a Editora Senac São Paulo reeditou e relançou
                  títulos publicados originalmente pelo Departamento
                  Nacional do Senac, reafirmando a missão institucional de
                  difundir conhecimento para capacitação técnica e
                  profissional de pessoas que atuam em diversas áreas
                  produtivas pelo Brasil.
                </p>
              </div>
            </div>
          </div>
          <Footer/>
        </div>
      </div>
    );
  }
}